import { Map, List, fromJS } from 'immutable';

import { HOTEL_HOVERED } from '../hotels/constants';
import { FILTRATION_SUCCESS } from '../filters/constants';
import { RESET_POPUP_DATA, SET_POPUP_DATA, TOGGLE_MAP } from './constants';

const initialState = fromJS({
  hotels: Map(),
  hotelsInList: List(),
  bounds: null,
  activeHotel: null,
  expanded: false,
  destinationBounds: null,
  popupData: {},
});

export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    case FILTRATION_SUCCESS: {
      const { hotels } = action.payload;
      const holetsInList = fromJS(
        hotels.map((hotelGroup) => hotelGroup.hotel.id),
      );
      const responseHotels = hotels.reduce((obj, hotel) => {
        // eslint-disable-next-line no-param-reassign
        obj[hotel.hotel.id] = {
          long: hotel.hotel.long,
          lat: hotel.hotel.lat,
        };
        return obj;
      }, {});
      return state.merge(
        fromJS({
          hotelsInList: holetsInList,
          hotels: responseHotels,
          activeHotel: {
            index: 0,
            id: hotels[0]?.hotel?.id,
            coordinates: [hotels[0]?.hotel?.long, hotels[0]?.hotel?.lat],
          },
        }),
      );
    }

    case TOGGLE_MAP:
      return state.set('expanded', !state.get('expanded'));

    case SET_POPUP_DATA:
      return state.set('popupData', fromJS(action.payload));

    case RESET_POPUP_DATA:
      return state.set('popupData', {});

    case HOTEL_HOVERED:
      return state.set('activeHotel', fromJS(action.payload));

    default:
      return state;
  }
}
